import React, {useEffect, useReducer} from "react";
import Grid from "@material-ui/core/Grid";
import {useLocation} from 'react-router-dom';
import {withApontamento} from '../contexts/ApontamentoProvider';
import {parse as qsParse} from 'query-string';
import Pendency from '../forms/Pendency';
import {Pendency as PendencyObj} from '../models/pendency';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {
    allocatePendency,
    getAllocatedPendecyStatus,
    getByAtividadesProjeto,
} from '../provider/pendency.service';
import moment from 'moment';
import localforage from '../utils/localforage';
import reducer from '../utils/defaultReducer';
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flex: 1,
        flexGrow: 1,
        position: 'relative',
        maxWidth: '100vw',
        [theme.breakpoints.up('sm')]: {
            height: '100%',
        }
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flex: 1,
        padding: '30px 30px 15px 30px',
        border: '0 !important',
        width: '100%',
    }
}))

function LinkPendency (props){
    const classes = useStyles()
    const location = useLocation()
    const initialState = {
        pendenciaId: '',
        queryString: new PendencyObj(),
        pendenciaData: new PendencyObj(),
        error: false
    };

    function verifyAllocatedPendency(idPendencia, querys){
        if (!idPendencia){
            if(querys.idAtividadeProjeto) {
                return getByAtividadesProjeto(querys.idAtividadeProjeto);
            }
            return Promise.reject();
        }
        const dataConsulta = moment(querys.dataHoraInicio).format('YYYY-MM-DD')
        return getAllocatedPendecyStatus(idPendencia, dataConsulta).then(({data: {data}}) => {
            let first = data[0];
            let confirm;
            if (first.status === 'CONFIRMACAO' && (confirm = window.confirm(first.resultado))) {
                return allocatePendency({
                    idPendencia,
                    idProjeto: first.idProjeto
                }, dataConsulta).then(({data: {data}}) => {
                    const dataPendency = data[0];
                    if (!dataPendency?.idAtividadeAlocada) {
                        window.alert(dataPendency.resultado);
                    } else {
                        return dataPendency;
                    }
                }).catch(() => {
                    window.alert("Erro ao alocar pendencia!");
                })
            } else if (first.status === 'CONFIRMACAO' && !confirm) {
                return new PendencyObj();
            }else if (first.status === 'OK') {
                return {
                    ...first,
                    pendenciaId: idPendencia
                };
            }
            else if (first.status === 'Erro') {
                window.alert(first.resultado)
                return new PendencyObj();
            }
        }).catch(() => {
            window.alert("Erro ao alocar apontamento!");
            return new PendencyObj();
        })
    }

    const [state, setState] = useReducer(reducer, initialState, () => initialState)

    useEffect(() => {
        const queryString = qsParse(location.search);
        queryString.dataHoraInicio = queryString.data;
        if(!queryString.horaInicio)
            queryString.horaInicio = moment().format('HH:mm')
        if(!queryString.horaFim)
            queryString.horaFim = null
        if(!queryString.descricao)
            queryString.descricao = ''
        verifyAllocatedPendency(queryString.pendenciaId, queryString).then((data) => {
            setState({
                pendenciaData: {
                    ...new PendencyObj(),
                    ...data,
                    ...queryString,
                },
            });
        }).catch((data) => {
            setState({
                pendenciaData: {
                    ...new PendencyObj(),
                    ...data,
                    ...queryString,
                },
            });
        })
    },[])


        return <Grid className={classes.container}>
            <Grid container justifyContent={'center'} alignContent={'center'} alignItems={'center'}>
                <Grid item xs={12} lg={6}>
                    <Paper className={classes.paper}>
                        <Typography variant={'h5'}>
                            Adicionar Apontamento via link (Beta)
                        </Typography>
                        <Pendency
                            data={{pendenciaId: props.match.params.id, ...state.pendenciaData}}
                            dateTime
                            withError={state.error}
                            hides={{btnCopy: true, btnShare: true}}
                            onSubmit={props.apontamentos.new(() => {
                                props.history.push('/apontamentos');
                            }, async () => {
                                setState({
                                    error: true,
                                    queryString: {
                                        ...await localforage.getItem('novo-apontamento')
                                    }
                                })
                                props.apontamentos.errorNotify(false);
                            })}/>
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
}

export default withApontamento(LinkPendency)
